import { DashboardMenu } from './DashboardMenu';
import { connect } from 'react-redux';
import {
  dashboardViewMenuOptionSel,
  dashboardViewActions
} from 'src/store/modules/dashboardview';

const mapStateToProps = (state: any) => {
  return {
    selected: dashboardViewMenuOptionSel(state)
  };
};

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  onSelect: (selected: 'switch' | 'manage' | 'password') => {
    dispatch(dashboardViewActions.setMenuOption(selected));
    dispatch(dashboardViewActions.setError());
    dispatch(dashboardViewActions.setHasSucceed(false));
  }
});

export const pureComponent = DashboardMenu;
export default connect(mapStateToProps, mapDispatchToProps)(DashboardMenu);

interface IDispatchFromProps {
  onSelect(selected: 'switch' | 'manage' | 'password'): void;
}
